export default __webpack_public_path__ + "static/media/brain.7b57b57d.png";